var map = {
	"./academia.webp": 84629,
	"./advertising.webp": 63054,
	"./cybersecurity.webp": 37143,
	"./insurance.webp": 33908,
	"./legal.webp": 74933,
	"./luxury.webp": 74621,
	"./news.webp": 37599,
	"./social.webp": 74907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81496;